module.exports = __webpack_public_path__ + "img/sublime-copy-filepaths.3688cc28.jpg";